import { Component, Input, Output, EventEmitter, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { PlatformUser } from '../../../../core/data-models/platform-user';
import { ModuleName } from '../../../../shared/enums/ModuleName';
import { ThemeModule } from '../../../../shared/Theme/theme.module';
import { ChildrenAnimation } from '../../../../shared/animations/allAnimations';

/**
 * Notification Settings Component
 * 
 * Handles user notification preferences including:
 * - Remaining units notifications
 * - Subscription expiring notifications
 * - Subscription expired notifications
 */
@Component({
    selector: 'notification-settings',
    standalone: true,
    imports: [
        CommonModule,
        FormsModule,
        ThemeModule,
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
    templateUrl: './notification-settings.component.html',
    styleUrls: ['./notification-settings.component.scss'],
    animations: [ChildrenAnimation]
})
export class NotificationSettingsComponent {
    readonly ModuleNames = ModuleName;

    @Input() user!: PlatformUser;
    @Input() language: string = 'EN';

    @Output() notificationChanged = new EventEmitter<PlatformUser>();

    /**
     * Emits when any notification setting changes
     */
    onNotificationChange(): void {
        this.notificationChanged.emit(this.user);
    }
}
